/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ProjectProxyRequestDto } from '../models/project-proxy-request-dto';

@Injectable({
  providedIn: 'root',
})
export class ProjectProxyControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectProxyControllerProxyApiCall
   */
  static readonly ProjectProxyControllerProxyApiCallPath = '/proxy-api-call';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyApiCall()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyApiCall$Response(params?: {
    body?: ProjectProxyRequestDto
  }): Observable<StrictHttpResponse<{  }>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectProxyControllerService.ProjectProxyControllerProxyApiCallPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{  }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyApiCall$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyApiCall(params?: {
    body?: ProjectProxyRequestDto
  }): Observable<{  }> {

    return this.proxyApiCall$Response(params).pipe(
      map((r: StrictHttpResponse<{  }>) => r.body as {  })
    );
  }

}
